var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "@elastic/eui/dist/eui_theme_amsterdam_light.css";
import { EuiPage, EuiPageBody } from "@elastic/eui";
import styled from "./Layout.styles";
import SideNavBar from "./SideNavBar";
var Layout = function (_a) {
    var className = _a.className, children = _a.children;
    return (_jsx("div", __assign({ className: className }, { children: _jsxs("div", __assign({ className: "Layout" }, { children: [_jsx(SideNavBar, {}), _jsx(EuiPage, __assign({ className: "Content", paddingSize: "none" }, { children: _jsx(EuiPageBody, { children: children }) }))] })) })));
};
export default styled(Layout);
